import css from "./index.module.css";
import AddIcon from "@mui/icons-material/Add";
import Input from "../../../../components/Input";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../../components/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useState } from "react";
import { v4 as uuid } from "uuid";
import { getDataById, insertData } from "../../../../utils/fetch";
/**
 * Displays a single entry from <StudentList /> for the addition of a new student
 * @param {String} classId 64 character uuid of given class
 * @param {Array} students Array of Objects with studentinformation
 * @param {Function} setStudents updates studentlist after the creation of a new student 
 */
const NewStudent = ({ classId, students, setStudents }) => {
  const [edit, setEdit] = useState(false);

  /**
   * adds a new student to the db
   * @param {Event} e form data 
   */
  const handleInsertStudent = (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const name = formData.get("newStudentName");
    const studentIsUnique = students?.find(f => f.name === name) === undefined;

    insertData("/api/students", {
      id: uuid(),
      name: studentIsUnique ? name : name + "" + students?.filter(f => f.name === name).length,
      classId: classId,
      challengeCode: Math.random().toString(36).substring(2, 7).toUpperCase(),
    }).then((res) => {
      getDataById("/api/students/byClass", { classId: classId }).then((data) =>
        setStudents(data)
      );
    });
    form.reset();
  };

  return (
    <>
      {edit ? (
        <form className={css.studentCard} id="newStudentCard" onSubmit={handleInsertStudent}>
          <div>
            <div className={css.avatar}>
              <CloseIcon onClick={() => setEdit(false)} />
            </div>
            <Input
              type="text"
              id="name"
              name="newStudentName"
              placeholder="Schüler:in hinzufügen"
              simple={true}
              style={css.studentinput}
            />
          </div>
          <Button simple={true} type="submit">
            <ArrowForwardIcon className={css.lightStroke}/>
          </Button>
        </form>
      ) : (
        <div className={css.studentCardCenter}>
          <div className={css.avatar}>
            <AddIcon onClick={() => setEdit(true)}/>
          </div>
        </div>
      )}
    </>
  );
};

export default NewStudent;
